import { render, staticRenderFns } from "./BloodPressureList.vue?vue&type=template&id=7a1b0980&scoped=true&"
import script from "./BloodPressureList.vue?vue&type=script&lang=js&"
export * from "./BloodPressureList.vue?vue&type=script&lang=js&"
import style0 from "./BloodPressureList.vue?vue&type=style&index=0&id=7a1b0980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1b0980",
  null
  
)

export default component.exports